/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import axios from 'axios';
import { API_ROOT } from './config';

const instance = axios.create({
  baseURL: API_ROOT,
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => response.data,
  (error) =>
    // 对响应错误做点什么
    Promise.reject(error)
);

export default {
  get: (url: any, params: any, config: any) => instance.get(url, { params, ...config }),
  post: (url: any, params: any, config: any) => instance.post(url, params, config),
  put: (url: any, params: any, config: any) => instance.put(url, params, config),
  delete: (url: any, params: any, config: any) => instance.delete(url, params),
};
